import React from 'react';
import { Divider } from 'semantic-ui-react'

const HomeConf1 = ({autorizacUA, styles, handleClickSel11, handleClickSel23, handleClickSel21, handleClickSel22, 
                    handleClickSel12, handleClickSel13, handleClickSel14, handleClickSel15, 
                    handleClickSel16, handleClickSel17, handleClickSel18}) => {
  const a2501 = autorizacUA.findIndex( autorizac => autorizac === "2501" );
  const a2503 = autorizacUA.findIndex( autorizac => autorizac === "2503" );
  const a2505 = autorizacUA.findIndex( autorizac => autorizac === "2505" );
  const a2510 = autorizacUA.findIndex( autorizac => autorizac === "2510" );
  const a2515 = autorizacUA.findIndex( autorizac => autorizac === "2515" );
  const a2520 = autorizacUA.findIndex( autorizac => autorizac === "2520" );
  // const a2525 = autorizacUA.findIndex( autorizac => autorizac === "2525" );
  // const a2530 = autorizacUA.findIndex( autorizac => autorizac === "2530" );
  // const a2535 = autorizacUA.findIndex( autorizac => autorizac === "2535" );
  const a2540 = autorizacUA.findIndex( autorizac => autorizac === "2540" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large settings yellow icon"></i>
        CONFIGURAR
      </button>

      {a2501!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel11}>
          <i className="large sitemap red icon"></i>
          Empresas
        </button>
      }
      {a2505!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel21}>
          <i className="large boxes red icon"></i>
          Unidades
        </button>
      }   
      {a2505!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel15}>
          <i className="large boxes red icon"></i>
          Tipos de hallazgos
        </button>
      }      
      {a2505!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel18}>
          <i className="large boxes red icon"></i>
          Tipos de mecanismos
        </button>
      }      
      {a2505!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel23}>
          <i className="large boxes red icon"></i>
          Programas para equipos
        </button>
      }
      <Divider inverted />
      {a2510!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel12}>
          <i className="large id card red icon"></i>
          Proveedores
        </button>
      }
      {a2510!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel13}>
          <i className="large shopping basket red icon"></i>
          Productos, programas y servicios
        </button>
      }
      {a2510!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel14}>
          <i className="large wrench red icon"></i>
          Materiales
        </button>
      }
      {a2515!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel16}>
          <i className="large newspaper red icon"></i>
          Encuesta comercial
        </button>
      }
      {a2520!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel17}>
          <i className="large handshake outline red icon"></i>
          Políticas comerciales
        </button>
      }
      <Divider inverted />
      {a2540!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel22}>
          <i className="large list alternate outline red icon"></i>
          Parametros
        </button>
      }
    </div>
  )
};

export default HomeConf1
